if (!customElements.get('product-showcase')) {
  customElements.define('product-showcase', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.run = this.querySelector('.product-showcase__run');
      this.pin = this.querySelector('.product-showcase__pin');
      this.nodes = [...this.querySelectorAll('.product-showcase__node')];
      this.panels = [...this.querySelectorAll('.product-showcase__panel')];
      this.groups = ['frame', 'spec', 'panel'].map(name => [...this.querySelectorAll('.product-showcase__' + name)]);
      this.count = this.nodes.length;
      if (!this.count) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.controller.signal });
      this.index = -1;
      this.set(0);
      this.fit = () => {
        const header = parseFloat(getComputedStyle(this).getPropertyValue('--hdH')) || 0;
        this.top = header + 12;
        this.pinned = this.dataset.scroll === 'true' && !this.motion.matches && !window.Shopify?.designMode && this.count > 1 && this.pin.offsetHeight <= innerHeight - this.top - 12;
        this.run.classList.toggle('is-pinned', this.pinned);
        this.step = innerHeight * .5;
        this.run.style.height = this.pinned ? `${this.pin.offsetHeight + (this.count - 1) * this.step}px` : '';
      };
      this.scroll = () => {
        if (!this.pinned || this.contains(document.activeElement)) return;
        const distance = this.top - this.run.getBoundingClientRect().top;
        this.set(Math.round(distance / this.step));
      };
      on(window, 'scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.scroll(); });
      });
      on(window, 'resize', this.fit);
      on(this.motion, 'change', this.fit);
      this.nodes.forEach((node, index) => {
        on(node, 'click', () => this.choose(index));
        on(node, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = Math.min(this.count - 1, index + 1);
          if (event.key === 'ArrowLeft') next = Math.max(0, index - 1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.count - 1;
          if (next !== undefined) { event.preventDefault(); this.nodes[next].focus(); this.choose(next); }
        });
      });
      on(this, 'focusout', () => requestAnimationFrame(() => this.scroll()));
      on(this, 'shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.set(index, true);
      });
      const stage = this.querySelector('.product-showcase__stage');
      on(stage, 'pointerdown', event => { this.pointer = { x: event.clientX, y: event.clientY }; });
      on(stage, 'pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x, dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.choose(this.index + (dx < 0 ? 1 : -1));
      });
      on(stage, 'pointercancel', () => { this.pointer = null; });
      this.resizeObserver = new ResizeObserver(this.fit);
      this.resizeObserver.observe(this.pin);
      this.fit();
    }
    choose(index) {
      index = Math.max(0, Math.min(this.count - 1, index));
      this.set(index, true);
      if (this.pinned) window.scrollTo({ top: this.run.getBoundingClientRect().top + scrollY - this.top + index * this.step, behavior: 'auto' });
    }
    set(index, announce = false) {
      index = Math.max(0, Math.min(this.count - 1, index));
      if (index === this.index) return;
      this.index = index;
      this.nodes.forEach((node, i) => {
        node.classList.toggle('is-on', i === index);
        node.classList.toggle('is-past', i < index);
        node.setAttribute('aria-pressed', String(i === index));
      });
      this.groups.forEach(group => group.forEach((element, i) => {
        element.classList.toggle('is-on', i === index);
        element.setAttribute('aria-hidden', String(i !== index));
      }));
      this.panels.forEach((panel, i) => { panel.inert = i !== index; });
      this.querySelector('.product-showcase__rail').style.setProperty('--p', this.count > 1 ? index / (this.count - 1) : 0);
      if (announce) this.querySelector('.product-showcase__live').textContent = `${this.nodes[index].getAttribute('aria-label')}, ${index + 1} of ${this.count}`;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
